import { render, staticRenderFns } from "./SolanStudentViewT.vue?vue&type=template&id=0adcfc71&scoped=true&"
import script from "./SolanStudentViewT.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewT.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewT.vue?vue&type=style&index=0&id=0adcfc71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adcfc71",
  null
  
)

export default component.exports